/**
 * What a seat bar says in words, in its tooltip: "SuPAR: 0 of 1 seat in use", and the idle seats
 * beside it when there are any. `used` counts seats still held; see `SeatUsageBar`.
 */
export const seatUsageText = (label: string, used: number, limit: number, reclaimable = 0) => {
  if (limit <= 0) return `${label}: not licensed`;

  const inUse = `${label}: ${used} of ${limit.formatCount('seat', 'seats')} in use`;

  return reclaimable > 0 ? `${inUse}, ${reclaimable} idle and free for the next client` : inUse;
};
